module.exports = __webpack_public_path__ + "static/media/å-lyd.98ae81b7.mp3";